<template>
    <div class="trader-list-page-view">
        <v-container>
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-card-title>
                            <v-icon color="primary">currency_exchange</v-icon>
                            <p class="body-1 mt-3 ml-3 font-weight-bold primary--text">
                                Trader List
                            </p>
                            <v-spacer></v-spacer>
                            <v-btn depressed rounded class="primary lighten-1" @click="() => (createDialog = true)">
                                <v-icon>add</v-icon>
                                create new trader
                            </v-btn>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="mt-5">
                            <v-data-table :page="page" :pageCount="numberOfPages" :search="search" :loading="loading"
                                :headers="headers" :items="traders" :items-per-page="itemsPerPage"
                                :options.sync="options" mobile-breakpoint="0" :server-items-length="totalCount">
                                <template v-slot:[`item.name`]="{ item }">
                                    <p
                                        class="number text--secondary blue--text font-weight-bold text-decoration-underline mt-4">
                                        {{ item.name }}</p>
                                </template>
                                <template v-slot:[`item.volumeTHB`]="{ item }">
                                    <p class="number text--secondary blue--text font-weight-medium font-mono mt-4">
                                        {{ item.volumeTHB }}</p>
                                </template>
                                <template v-slot:[`item.tradeCount`]="{ item }">
                                    <p class="number text--secondary blue--text font-weight-medium font-mono mt-4">
                                        {{ item.tradeCount }}</p>
                                </template>
                                <template v-slot:[`item.rateFor100`]="{ item }">
                                    <p class="number text--secondary blue--text font-weight-medium font-mono mt-4">
                                        {{ item.rateFor100 }}</p>
                                </template>
                                <template v-slot:[`item.rateFor5000`]="{ item }">
                                    <p class="number text--secondary blue--text font-weight-medium font-mono mt-4">
                                        {{ item.rateFor5000 }}</p>
                                </template>
                                <template v-slot:[`item.rateFor10000`]="{ item }">
                                    <p class="number text--secondary blue--text font-weight-medium font-mono mt-4">
                                        {{ item.rateFor10000 }}</p>
                                </template>
                                <template v-slot:[`item.rateFor100000`]="{ item }">
                                    <p class="number text--secondary blue--text font-weight-medium font-mono mt-4">
                                        {{ item.rateFor100000 }}</p>
                                </template>
                                <template v-slot:[`item.update`]="{ item }">
                                    <v-btn icon @click="() => handleShowUpdateDialog(item)"
                                        class="text-secondary"><v-icon>edit</v-icon></v-btn>
                                </template>
                                <template v-slot:[`item.delete`]="{ item }">
                                    <v-btn icon @click="
                                        () => {
                                            deleteDialog = true;
                                            selectedItem = item._id;
                                        }
                                    " class="text-secondary"><v-icon>delete</v-icon></v-btn>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>


        <v-dialog v-model="createDialog" width="500">
            <v-card>
                <v-card-title>
                    <v-icon color="primary">currency_exchange</v-icon>
                    <p class="body-1 mt-3 ml-3 font-weight-bold primary--text">
                        Create A New Trader
                    </p>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="mt-5">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="Trader Name" placeholder="Enter trader name" filled rounded x-large
                                type="text" v-model="traderName" />
                            <v-text-field label="Rate For 100" placeholder="0" filled rounded x-large type="number"
                                v-model="traderRateFor100" />
                            <v-text-field label="Rate For 5000" placeholder="0" filled rounded x-large type="number"
                                v-model="traderRateFor5000" />
                            <v-text-field label="Rate For 10000" placeholder="0" filled rounded x-large type="number"
                                v-model="traderRateFor10000" />
                            <v-text-field label="Rate For 100000" placeholder="0" filled rounded x-large type="number"
                                v-model="traderRateFor100000" />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="secondary" text x-large @click="() => (createDialog = false)">
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text x-large :loading="addLoading" @click="handleAddNew">
                        <v-icon>save</v-icon>
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="updateDialog" width="500">
            <v-card>
                <v-card-title>
                    <v-icon color="primary">currency_exchange</v-icon>
                    <p class="body-1 mt-3 ml-3 font-weight-bold primary--text">
                        Update Trader
                    </p>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="mt-5">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="Trader Name" placeholder="Enter trader name" filled rounded x-large
                                type="text" v-model="traderName" />
                            <v-text-field label="Rate For 100" placeholder="0" filled rounded x-large type="number"
                                v-model="traderRateFor100" />
                            <v-text-field label="Rate For 5000" placeholder="0" filled rounded x-large type="number"
                                v-model="traderRateFor5000" />
                            <v-text-field label="Rate For 10000" placeholder="0" filled rounded x-large type="number"
                                v-model="traderRateFor10000" />
                            <v-text-field label="Rate For 100000" placeholder="0" filled rounded x-large type="number"
                                v-model="traderRateFor100000" />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="secondary" text x-large @click="() => (updateDialog = false)">
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text x-large :loading="updateLoading" @click="handleUpdate">
                        <v-icon>save</v-icon>
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deleteDialog" width="500">
            <v-card>
                <v-card-title>
                    <v-icon color="red">warning</v-icon>
                    <p class="body-1 mt-3 ml-3 font-weight-bold red--text">Warning</p>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="mt-5">
                    Please confirm that you want to delete this trade.This action can't be
                    revert.
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="secondary" text x-large @click="() => (deleteDialog = false)">
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="red" text x-large :loading="deleteLoading" @click="handleDeleteTrader">
                        <v-icon>delete</v-icon>
                        delete trader
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>
<script>
import { traderApi } from "@/api"

export default {
    name: "TraderListPageView",
    data: function () {
        return {
            page: 1,
            numberOfPages: null,
            search: null,
            loading: false,
            traders: [],
            itemsPerPage: 10,
            totalCount: null,
            options: {},
            headers: [
                {
                    text: "Name", value: "name"
                },
                {
                    text: "Volume In THB", value: "volumeTHB"
                },
                {
                    text: "Trade Count", value: "tradeCount"
                },
                {
                    text: "Rate For 100", value: "rateFor100"
                },
                {
                    text: "Rate For 5000", value: "rateFor5000"
                },
                {
                    text: "Rate For 10000", value: "rateFor10000"
                },
                {
                    text: "Rate For 100000", value: "rateFor100000"
                },
                {
                    text: "Update", value: "update"
                },
                {
                    text: "Delete", value: "delete"
                },
            ],
            createDialog: false,
            addLoading: false,
            deleteDialog: false,
            deleteLoading: false,
            updateDialog: false,
            updateLoading: false,
            traderName: "",
            traderRateFor100: "",
            traderRateFor5000: "",
            traderRateFor10000: "",
            traderRateFor100000: "",
            selectedItem: null
        }
    },
    methods: {
        handleAddNew: async function () {
            this.addLoading = true;

            const trader = {
                name: this.traderName,
                rateFor100: this.traderRateFor100,
                rateFor5000: this.traderRateFor5000,
                rateFor10000: this.traderRateFor10000,
                rateFor100000: this.traderRateFor100000
            }

            try {
                await traderApi.createTrader(trader);
                this.loadTraders(this.options.page, this.options.itemsPerPage);
            } catch (error) {
                console.log(error);
            }

            this.addLoading = false;
            this.createDialog = false;
        },
        handleUpdate: async function () {
            this.updateLoading = true;

            const trader = {
                name: this.traderName,
                rateFor100: this.traderRateFor100,
                rateFor5000: this.traderRateFor5000,
                rateFor10000: this.traderRateFor10000,
                rateFor100000: this.traderRateFor100000
            }

            try {
                await traderApi.updateTrader(this.selectedItem, trader)
                this.loadTraders(this.options.page, this.options.itemsPerPage);
            } catch (error) {
                console.log(error);
            }

            this.updateLoading = false;
            this.updateDialog = false;
        },
        handleShowUpdateDialog: function (item) {
            this.selectedItem = item._id
            this.traderName = item.name
            this.traderRateFor100 = item.rateFor100
            this.traderRateFor5000 = item.rateFor5000
            this.traderRateFor10000 = item.rateFor10000
            this.traderRateFor100000 = item.rateFor100000

            this.updateDialog = true;
        },
        handleShowDeleteDialog: function (item) {
            this.selectedItem = item._id;
            this.deleteDialog = true;
        },
        handleDeleteTrader: async function () {
            this.deleteLoading = true;

            try {
                await traderApi.deleteTrader(this.selectedItem)
                this.loadTraders(this.options.page, this.options.itemsPerPage);
            } catch (error) {
                console.log(error);
            }

            this.deleteLoading = false;
            this.deleteDialog = false;
        },  
        loadTraders: async function (page, limit) {
            this.loading = true;

            try {
                const data = await traderApi.getTraders(page, limit);

                console.log(data);


                this.traders = data.traders;
                this.page = data.currentPage;
                this.numberOfPages = data.totalPages;
                this.totalCount = data.totalCount;
            } catch (error) {
                console.log(error);
            }

            this.loading = false;
        }
    },
    watch: {
        options: function (options) {
            this.loadTraders(options.page, options.itemsPerPage);
        }
    }
}

</script>